var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcArrowPrimary = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5DBA729B-BBF4-4A74-A4D8-F1DF4DFE01BDsvg")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-DJ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01108-\\u201CCourses\\u201D-page",
    transform: "translate(-1252.000000, -276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-list",
    transform: "translate(296.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(12.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Primary-Copy-5",
    transform: "translate(888.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.100000001,
    x: 0,
    y: 0,
    width: 80,
    height: 26,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/16/external-link",
    transform: "translate(56.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.333333, 2.000000)",
    fill: "#556EE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2840757,5.39616732 L0.95074239,0.0628339891 C0.717409057,-0.0458326775 0.442075724,-0.0118326775 0.243409057,0.151500656 C0.0440757236,0.314833989 -0.0419242764,0.578167322 0.0200757236,0.827500656 L1.31274239,5.99950066 L0.0200757236,11.1715007 C-0.042590943,11.420834 0.0440757236,11.684834 0.243409057,11.8481673 C0.365409057,11.9481673 0.51474239,11.9995007 0.66674239,11.9995007 C0.763409057,11.9995007 0.860075724,11.978834 0.95074239,11.9361673 L12.2840757,6.60283399 C12.5174091,6.49283399 12.6667424,6.25816732 12.6667424,5.99950066 C12.6667424,5.74083399 12.5174091,5.50616732 12.2840757,5.39616732 Z M1.65407572,10.130834 L2.21340906,7.89283399 L6.00007572,5.99950066 L2.21340906,4.10616732 L1.65407572,1.86816732 L10.4340757,5.99950066 L1.65407572,10.130834 Z",
    id: "Shape"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcArrowPrimary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_arrow_primary.8fcacc40.svg";
export { ForwardRef as ReactComponent };